export const getAbsoluteUrl = (url) => {
    if (!url)
        return undefined;
    return new URL(url, document.baseURI);
};
//# sourceMappingURL=getAbsoluteUrl.js.map